module.exports = __webpack_public_path__ + "media/images/home/cv_bg-5b7bdf2d15d88764575c7a74cbcfd8c1.png";